import { render, staticRenderFns } from "./blMode.vue?vue&type=template&id=7c703712&"
import script from "./blMode.vue?vue&type=script&lang=js&"
export * from "./blMode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c703712')) {
      api.createRecord('7c703712', component.options)
    } else {
      api.reload('7c703712', component.options)
    }
    module.hot.accept("./blMode.vue?vue&type=template&id=7c703712&", function () {
      api.rerender('7c703712', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/blMode.vue"
export default component.exports